import { reactive, type App } from 'vue'

import { getApolloClient, createAllVerticalClients } from '@/lib/apollo-client'
import { ApolloClients } from '@vue/apollo-composable'
import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'

export type InjectedApolloObject = {
  client: ApolloClient<NormalizedCacheObject> | null
}

const reactiveApolloClient = reactive<InjectedApolloObject>({
  client: null,
})

/**
 * Store the app so that if we don't have a vertical on application load,
 * the client can be updated later. This can occur during purchase flow.
 */
let _app: App | null = null

/**
 * *(AI-generated)*
 * Installs the Apollo Client into the Vue app and sets it as the active Apollo client for the given vertical.
 */
export function provideApolloClient(app: App) {
  if (app) {
    _app = app
  }
  const client = getApolloClient()
  setApolloClient(client)
}

function setApolloClient(client: ApolloClient<NormalizedCacheObject>) {
  if (_app) {
    reactiveApolloClient.client = client
    if (!_app.config.globalProperties.$apollo) {
      _app.provide('apollo', reactiveApolloClient)
      _app.provide(ApolloClients, createAllVerticalClients())
    }
  }
}
